import { ContentObjectDetail } from '../content-object-detail';
import { useKudoQuery } from '../queries';

type P = {
  kudosId: string;
};

const KudoDetail = ({ kudosId }: P) => {
  const { data: contentObject, isLoading } = useKudoQuery(kudosId);

  return <ContentObjectDetail contentObject={contentObject} isLoading={isLoading} />;
};

export default KudoDetail;
